import { Language } from './types'

// BCP-47 locale tag per supported UI language. Drives Intl date/number
// formatting so dates render in the active language (e.g. "5. november 2025"
// in Norwegian vs "November 5, 2025" in English).
const LOCALE_TAGS: Record<Language, string> = { nb: 'nb-NO', en: 'en-US' }

export function localeTag(language: Language): string {
  return LOCALE_TAGS[language]
}

// Format an ISO date string as a long-form date in the active language.
// Throws on an unparseable input rather than silently rendering "Invalid Date".
export function formatLongDate(dateString: string, language: Language): string {
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) {
    throw new Error(`Date formatting failed: "${dateString}" is not a parseable date (language "${language}").`)
  }
  return date.toLocaleDateString(LOCALE_TAGS[language], { year: 'numeric', month: 'long', day: 'numeric' })
}
